// §4.4 partial — matrix route set.
// Covers: /matrix (requests default), /matrix/users, /matrix/users/:id,
//         /matrix/logs, /matrix/requests
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "@/features/admin/_layout/AdminLayout";

const MatrixPage = lazyWithRetry(() => import("./pages/MatrixPage"));
const MatrixUserDetailPage = lazyWithRetry(
  () => import("./pages/MatrixUserDetailPage"),
);
const MatrixLogsPage = lazyWithRetry(() => import("./pages/MatrixLogsPage"));

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/matrix", Component: MatrixPage },
      { path: "/matrix/users", Component: MatrixPage },
      { path: "/matrix/users/:id", Component: MatrixUserDetailPage },
      { path: "/matrix/logs", Component: MatrixLogsPage },
      { path: "/matrix/requests", Component: MatrixPage },
    ],
  },
];

export default routes;
